import { ImageModal } from '@/shared/components/ui/Images/ImageListModal/ImageListModal';
import { getDocumentById } from '../actions/erp/file-document.actions';
import { urlDrive } from '../constants/networking.constants';
import { ApiFileRespAWT } from '../interfaces';

export const extractIdFromUrl = (url: string): string => {
  const regex = /archivos\/([a-f0-9\-]{36})\//;
  const match = url.match(regex);
  return match ? match[1] : '';
};

export const extractUID = (url: string): string => {
  if (!url) return '';
  // Definir una expresión regular para capturar el UID
  const regex = /\/([\da-f]{8}-[\da-f]{4}-[\da-f]{4}-[\da-f]{4}-[\da-f]{12})\./;
  // Ejecutar la expresión regular en la URL
  const match = url.match(regex);
  // Si encontramos una coincidencia, devolver el UID, de lo contrario, devolver null
  return match ? match[1] : '';
}

export const extractIdsFromUrls = (urls: string[]): string[] => {
  const regex = /\/(\d+)\/descargar\/?/;

  return urls.map(url => {
    const match = url.match(regex);
    return match ? match[1] : '';
  });
};

export type PreventasImagesParams = {
  cargar_cedula: string;
  cargar_cedula_reverso: string | undefined;
  foto_aceptacion_cliente: string;
  tarjeta_foto: string | undefined;
  foto_respaldo_cuenta_bancaria: string | undefined;
};

export const preventaImages = async (
  images: PreventasImagesParams
): Promise<ImageModal[]> => {
  const imagePathAndName = await Promise.all(
    Object.values(images).map(async url => {
      const id = extractIdFromUrl(url!);
      if (!id) return;
      const res = await getDocumentById(+id);
      return {
        img: urlDrive + res.data.id_archivos + '/descargar/',
        title: res.data.nombre,
        id: res.data.id_archivos,
      };
    })
  );

  return imagePathAndName.filter(Boolean) as ImageModal[];
};

export const extractIdsFromObjRes = (imagesArr: ApiFileRespAWT[]) => {
  return imagesArr.map(image => image?.id_archivos).filter(Boolean);
};